import styled from "styled-components";
import { responsiveWidth } from "responsive";

export const Container = styled.div`
  img {
    width: 100%;
    height: 448px;
    object-fit: cover;
  }

  @media (min-width: 1921px) {
    img {
      width: 100%;
      height: 40vh;
      object-fit: cover;
    }
  }

  @media (min-width: 1351px) and (max-width: 1920px) {
    img {
      width: 100%;
      height: 375px;
      object-fit: cover;
    }
  }

  @media (min-width: 1025px) and (max-width: 1350px) {
    img {
      width: 100%;
      height: 309px;
      object-fit: cover;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    img {
      width: 100%;
      height: 236px;
      object-fit: cover;
    }
  }

  @media (min-width: 568px) and (max-width: 767px) {
    img {
      width: 100%;
      height: 544px;
      object-fit: cover;
    }
  }

  @media (max-width: 567px) {
    img {
      width: 100%;
      height: 342px;
      object-fit: cover;
    }
  }

  .swiper-pagination-bullet-active {
    background: #ffffff;
    color: #ffffff;
  }

  .swiper-pagination-bullet {
    background: #ffffff80;
  }

  .swiper-button {
    ${responsiveWidth}
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
    margin: 0 auto;
    right: 0;
    left: 0;
  }

  .swiper-button-prev,
  .swiper-button-next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    color: #fff;
    z-index: 11;
    pointer-events: auto;
  }

  .swiper-button-prev {
    cursor: pointer;
    left: 0;
  }

  .swiper-button-next {
    cursor: pointer;
    right: 0;
  }
`;

export const AboutYeolMae = styled.div`
  .about {
    .text {
      color: #000;
      font-size: 24px;
      font-weight: bold;
      padding: 10px 20px;
      border-radius: 5px;

      .title {
        color: #000;
        font-family: NanumSquareOTF;
        font-size: 50px;
        font-style: normal;
        font-weight: 800;
        line-height: 60px; /* 94% */
        letter-spacing: -2.5px;
      }

      .content {
        margin-top: 20px;
        color: #000;
        font-family: NanumSquareOTF;
        font-size: 17px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 64.706% */
        letter-spacing: -0.85px;
      }
    }
  }

  @media (min-width: 1441px) {
    .about {
      position: relative;
      width: 100%;

      .text {
        padding: unset;
        position: absolute;
        top: 169px;
        left: 63 0px;
      }

      img {
        width: 100%;
        flex-shrink: 0;
        background: url(<path-to-image>) lightgray 0px -290.533px / 99.585% 145.126%
          no-repeat;
        display: block;
      }
    }
  }

  @media (max-width: 567px) {
    .about {
      .text {
        .title {
          color: #3e3a39;
          font-family: NanumSquareOTF;
          font-size: 25px;
          font-style: normal;
          font-weight: 800;
          line-height: 35px; /* 110% */
          letter-spacing: -1.25px;
        }

        .content {
          color: #3e3a39;
          font-family: NanumSquareOTF;
          font-size: 15px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px; /* 24% */
          letter-spacing: -0.75px;

          .web {
            display: none;
          }
        }
      }

      img {
        margin-top: 20px;
        width: 100%;
        height: 248px;
        flex-shrink: 0;
        background: url(<path-to-image>) lightgray 0px -290.533px / 99.585% 145.126%
          no-repeat;
      }
    }
  }
`;
